import {
  Users,
  Globe,
  Heart,
  Compass,
  BookOpen,
  Church,
  Crown,
  GraduationCap,
  Star,
  Baby,
  Landmark,
} from "lucide-react";
import type { InstitutionConfig } from "../types";

/**
 * Color preset options for institution banners.
 */
export const GRADIENT_PRESETS = [
  { label: "Cian",      value: "linear-gradient(135deg, #06b6d4 0%, #3b82f6 100%)" },
  { label: "Rosa",      value: "linear-gradient(135deg, #ec4899 0%, #f43f5e 100%)" },
  { label: "Naranja",   value: "linear-gradient(135deg, #f97316 0%, #ef4444 100%)" },
  { label: "Verde",     value: "linear-gradient(135deg, #10b981 0%, #14b8a6 100%)" },
  { label: "Índigo",    value: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)" },
  { label: "Ámbar",     value: "linear-gradient(135deg, #f59e0b 0%, #f97316 100%)" },
  { label: "Fuchsia",   value: "linear-gradient(135deg, #d946ef 0%, #ec4899 100%)" },
  { label: "Esmeralda", value: "linear-gradient(135deg, #34d399 0%, #10b981 100%)" },
  { label: "Cielo",     value: "linear-gradient(135deg, #0ea5e9 0%, #06b6d4 100%)" },
  { label: "Rojo",      value: "linear-gradient(135deg, #ef4444 0%, #f97316 100%)" },
  { label: "Violeta",   value: "linear-gradient(135deg, #a855f7 0%, #6366f1 100%)" },
  { label: "Teal",      value: "linear-gradient(135deg, #2dd4bf 0%, #34d399 100%)" },
];

/**
 * Static per-slug config: icon, name fallback, and default gradient.
 * Name/description/gradient are DB-managed; name here is a fallback for
 * modules that don't load from DB (e.g. tithes matrix).
 */
export const INSTITUTION_CONFIGS: InstitutionConfig[] = [
  { slug: "ministerio-mujer",           name: "Ministerio de la Mujer",                       icon: Heart,         defaultGradient: "linear-gradient(135deg, #ec4899 0%, #f43f5e 100%)" },
  { slug: "embajadores-de-cristo",      name: "Embajadores de Cristo",                        icon: Globe,         defaultGradient: "linear-gradient(135deg, #6366f1 0%, #3b82f6 100%)" },
  { slug: "misioneritas",               name: "Misioneritas",                                 icon: Star,          defaultGradient: "linear-gradient(135deg, #f97316 0%, #f59e0b 100%)" },
  { slug: "exploradores-del-rey",       name: "Exploradores del Rey",                         icon: Compass,       defaultGradient: "linear-gradient(135deg, #10b981 0%, #14b8a6 100%)" },
  { slug: "escuela-biblica",            name: "Escuela Bíblica",                              icon: BookOpen,      defaultGradient: "linear-gradient(135deg, #a855f7 0%, #6366f1 100%)" },
  { slug: "direccion-nacional-misiones",name: "Dirección Nacional de Misiones",               icon: Globe,         defaultGradient: "linear-gradient(135deg, #0ea5e9 0%, #06b6d4 100%)" },
  { slug: "ministerio-pastoras",        name: "Ministerio de Pastoras y Esposas de Pastores", icon: Church,        defaultGradient: "linear-gradient(135deg, #d946ef 0%, #ec4899 100%)" },
  { slug: "castillos-del-rey",          name: "Castillos del Rey",                            icon: Crown,         defaultGradient: "linear-gradient(135deg, #f59e0b 0%, #f97316 100%)" },
  { slug: "sec",                        name: "Servicio de Educación Cristiana",               icon: GraduationCap, defaultGradient: "linear-gradient(135deg, #6366f1 0%, #0ea5e9 100%)" },
  { slug: "chi-alpha",                  name: "Chi Alpha",                                    icon: Users,         defaultGradient: "linear-gradient(135deg, #ef4444 0%, #f97316 100%)" },
  { slug: "hijos-de-ministros",         name: "Hijos de Ministros",                           icon: Baby,          defaultGradient: "linear-gradient(135deg, #2dd4bf 0%, #34d399 100%)" },
  { slug: "directorio-nacional",        name: "Directorio Nacional",                           icon: Landmark,      defaultGradient: "linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%)" },
];

/** @deprecated use INSTITUTION_CONFIGS — kept for tithes backward compat */
export const INSTITUTIONS = INSTITUTION_CONFIGS;

export function getInstitutionConfig(slug: string): InstitutionConfig | undefined {
  return INSTITUTION_CONFIGS.find((c) => c.slug === slug);
}

/** Returns the localStorage key for a given institution's settings. */
export function getSettingsKey(slug: string): string {
  return `institution-settings-${slug}`;
}
